import { IWPLink } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";

type GroupData = {
  title: string;
  address: {
    street: string;
    city: string;
    zip: string;
    country: string;
    phone: string;
  };
  contacts: {
    contact: {
      title: string;
      email: string;
    }[];
  };
};

export type IFooterData = {
  wp: {
    siteSettings: {
      siteSettings: {
        footer: {
          stockholm: GroupData;
          copenhagen: GroupData;
          socialMedia: {
            title: string;
            links: {
              link: IWPLink;
            }[];
          };
        };
      };
    };
  };
};

const useFooterData = () => {
  const { wp }: IFooterData = useStaticQuery(
    graphql`
      {
        wp {
          siteSettings {
            siteSettings {
              footer {
                stockholm {
                  title
                  address {
                    city
                    country
                    phone
                    street
                    zip
                  }
                  contacts {
                    contact {
                      email
                      title
                    }
                  }
                }
                copenhagen {
                  address {
                    city
                    country
                    phone
                    street
                    zip
                  }
                  contacts {
                    contact {
                      email
                      title
                    }
                  }
                  title
                }
                socialMedia {
                  title
                  links {
                    link {
                      target
                      title
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  );
  return wp.siteSettings.siteSettings;
};
export default useFooterData;
